module.exports = __webpack_public_path__ + "static/img/avel-chuklanov-2hmXvBevyX8-unsplash_thumb.a7eaa5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/avel-chuklanov-2hmXvBevyX8-unsplash_thumb.png
// module id = Ple8
// module chunks = 4